import {sortingInit} from '../../js/partials/sorting-bar';
import {scrollIntoView} from '../../js/utils/scrollIntoView';
import {initProductImageChange} from '../../js/utils/changeProductImage';

const loadMore = async (e) => {
    e.preventDefault();
    const currentScrollPosition = window.scrollY;
    const collectionMainElement = document.querySelector('[data-js-selector="collection-main"]');
    const url = new URL(e.target.href);
    const params = new URLSearchParams(url.search);

    collectionMainElement.setAttribute('data-loading', true);

    await fetch(url.href)
        .then(function(res) {
            if (!res.ok) {
                collectionMainElement.setAttribute('data-loading', false);
                throw new Error('Network response was not ok');
            }
            return res.text();
        })
        .then(function(res) {
            const container = document.querySelector('.product-grid');
            const parser = new DOMParser();
            const doc = parser.parseFromString(res, 'text/html');
            const items = doc.querySelectorAll('.product-grid .product__card');
            const pag = doc.querySelector('.pagination');
            document.querySelector('.pagination').innerHTML = pag.innerHTML;
            setTimeout(() => {
                document.querySelector('.loadmore').addEventListener('click', loadMore);
            }, 1000);

            items.forEach((item) => {
                container.appendChild(item);
            });
            const hasPage = params.get('page');

            if (hasPage) {
                const page = Number(params.get('page')) + 1;
                params.set('page', page);
            } else {
                params.set('page', 2);
            }
            e.target.href = ''.concat(url.origin).concat(url.pathname, '?');
            const params2 = new URLSearchParams(url.search);
            window.history.pushState({}, '', '?' + params2.toString());

            if (params.get('page') === e.target.dataset.lastPage) {
                e.target.style.display = 'none';
            }
            collectionMainElement.setAttribute('data-loading', false);
            window.scrollTo({
                top: currentScrollPosition,
                behavior: 'instant'
            });

            initProductImageChange();
        })
        .catch((error) => {
            console.error('Fetch error:', error);
            collectionMainElement.setAttribute('data-loading', false);
        });
};

const fetchAndUpdateContent = function(pageUrl) {
    const collectionMainElement = document.querySelector('[data-js-selector="collection-main"]');
    collectionMainElement.setAttribute('data-loading', true);
    fetch(pageUrl)
        .then((response) => {
            if (!response.ok) {
                collectionMainElement.setAttribute('data-loading', false);
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then((htmlString) => {
            const parser = new DOMParser();
            const html = parser.parseFromString(htmlString, 'text/html');

            const oldSections = document.querySelectorAll('.refreshWithPagination');
            const newSections = html.querySelectorAll('.refreshWithPagination');
            oldSections.forEach((oldSection, index) => {
                const newSection = newSections[index];
                oldSection.innerHTML = newSection.innerHTML;
            });
            paginationInit();
            sortingInit();
            collectionMainElement.setAttribute('data-loading', false);
            scrollIntoView('[data-js-selector="collection-main-products"]');
            initProductImageChange();
        })
        .catch((error) => {
            console.error('Fetch error:', error);
            collectionMainElement.setAttribute('data-loading', false);
        });
};

export const paginationInit = () => {
    const loadmoreButton = document.querySelector('.loadmore');
    const paginationButtons = document.querySelectorAll('[data-js-selector="pagination-button"]');

    if (loadmoreButton) {
        loadmoreButton.addEventListener('click', loadMore);
    }

    paginationButtons.forEach((paginationButton) => {
        paginationButton.addEventListener('click', (event) => {
            event.preventDefault();
            window.history.pushState(
                {
                    path: event.currentTarget.href,
                },
                '',
                event.currentTarget.href,
            );
            fetchAndUpdateContent(event.currentTarget.href);
        });
    });
};
